import { useEffect, useState } from "react";

interface ScrollableElement extends HTMLElement {
	scrollLeftMax: number;
	scrollTopMax: number;
}

interface useScrollProps {
	el: React.MutableRefObject<null | ScrollableElement>;
}

export interface useScrollData {
	scrollHeight: number;
	scrollWidth: number;
	scrollLeft: number;
	scrollTop: number;
	scrollLeftMax: number;
	scrollTopMax: number;
}

const useScroll = ({ el }: useScrollProps): useScrollData | null => {
	const [scrollData, setScrollData] = useState<null | useScrollData>(null);
	useEffect(() => {
		if (el.current instanceof Element) {
			el.current.dispatchEvent(new Event("scroll"));
			if (!(el.current as HTMLElement).onscroll) {
				(el.current as HTMLElement).onscroll = () => {
					setScrollData({
						scrollHeight: el.current!.scrollHeight,
						scrollWidth: el.current!.scrollWidth,
						scrollLeft: el.current!.scrollLeft,
						scrollTop: el.current!.scrollTop,
						scrollLeftMax: el.current!.scrollLeftMax || 1,
						scrollTopMax: el.current!.scrollTopMax || 1,
					});
				};
			}
		}
	}, [el]);
	return scrollData;
};

export default useScroll;
